import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { getAnalyticsConsent, setAnalyticsConsent } from "../../utils/analytics";
import "./CookieConsent.css";

// Pages that show the choice in the page (<CookieConsent inline />), because on a phone the fixed banner
// covers their only buttons.
const INLINE_ROUTES = ["/c/"];

/**
 * Consent gate for the PostHog analytics cookie.
 *
 * Shown until the visitor chooses. Analytics stays off until "Accept" — under
 * ePrivacy, consent has to come before a non-essential cookie is set, so a
 * banner that only informs would not be enough. Declining is a real choice and
 * keeps analytics off; the app works either way.
 */
function CookieConsent({ inline = false }) {
  const { pathname } = useLocation();
  const [, rerender] = useState(0);

  // Read on every render: an in-page copy and the app-wide one share the cookie, not state.
  if (getAnalyticsConsent() !== null) return null;
  // Lowercased: routes match regardless of case, so /C/JORDANLEE is the creator page too.
  if (!inline && INLINE_ROUTES.some((route) => pathname.toLowerCase().startsWith(route))) return null;

  const choose = (granted) => {
    setAnalyticsConsent(granted);
    rerender((n) => n + 1);
  };

  return (
    <div
      className={inline ? "cookie-consent cookie-consent--inline" : "cookie-consent"}
      role={inline ? "region" : "dialog"}
      aria-live="polite"
      aria-label="Cookie preferences"
    >
      <div className="cookie-consent__inner">
        <p className="cookie-consent__copy">
          We use a cookie to measure how JobHarvest is used so we can improve it.
          It is not used for advertising and we never sell your data. Essential
          cookies that keep you signed in are always on. See our{" "}
          <Link to="/landing-pages/privacy" className="cookie-consent__link">
            Privacy Policy
          </Link>
          .
        </p>
        <div className="cookie-consent__actions">
          <button
            type="button"
            className="cookie-consent__btn cookie-consent__btn--ghost"
            onClick={() => choose(false)}
          >
            Decline
          </button>
          <button
            type="button"
            className="cookie-consent__btn cookie-consent__btn--primary"
            onClick={() => choose(true)}
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;
